module.exports = __webpack_public_path__ + "img/bg_u.60105713.png";